import {
  RequestorConditionsValues,
  ApprovalBranchViewRowValues,
  ApprovalLevelViewRowValues,
  ApprovalValues,
} from './types';

export const CONDITION_NODE_WIDTH = 300;
export const CONDITION_NODE_HEIGHT = 110;

export const LEVEL_NODE_HEIGHT = 110;
export const LEVEL_NODE_WIDTH = 300;

export const BRANCH_NODE_HEIGHT = 110;
export const BRANCH_NODE_WIDTH = 300;
export const MAX_CHAR_COUNT = 100;

export const REQUESTOR_INITIAL_VALUES: RequestorConditionsValues = {
  id: null,
  _isDeletable: null,
  _isUpdatable: null,
  _rowTimestamp: null,
  approvalId: null,
  approval: null,
  importanceLevel: null,
  description: null,
  startAmountTotal: null,
  endAmountTotal: null,
  requesterCurrencyId: null,
  amountConversionTypeId: null,
  requesterUserOccupationTitleId: null,
  requesterDepartmentId: null,
  requesterDepartmentTypeId: null,
  requesterDepartmentGroupId: null,
  requesterSecureRowLevelId: null,
  startElapsedDays: null,
  endElapsedDays: null,
  requesterTagId: null,
  requesterUserRankId: null,
  requesterCompanyId: null,
  requesterBusinessUnitId: null,
  requesterUserId: null,
  requesterPurchaseOrderTypeId: null,
  isAutoApprovedEligible: null,
  isAndCondition: null,
};
export const APPROVAL_BRANCH_INITIAL_VALUES: ApprovalBranchViewRowValues = {
  id: null,
  branchOrder: null,
  description: null,
  _isDeletable: null,
  _isUpdatable: null,
  userOccupation: null,
  _rowTimestamp: null,
  userRank: null,
  budgetLimitAmount: null,
  budgetLimitPercent: null,
  isOverBudgetSelector: null,
  isBusinessUnitSelector: null,
  isUserGroupSelector: null,
  isWorkgroupSelector: null,
  isProjectSelector: null,
  isDepartmentSelector: null,
  transactionStartAmountTotal: null,
  transactionEndAmountTotal: null,
  transactionAmountConversionTypeId: null,
  approverTransactionTypeId: null,
  transactionBusinessUnitId: null,
  transactionDepartmentId: null,
  transactionDepartmentGroupId: null,
  isTransactionNotCondition: null,
  approverDelayDays: null,
  requesterUserId: null,
  approverDelayHours: null,
  approverDelayStatusTypeId: null,
};
export const APPROVAL_LEVELS_INITIAL_VALUES: ApprovalLevelViewRowValues = {
  id: null,
  approvalLevel: null,
  name: null,
  description: null,
  _isDeletable: null,
  _isUpdatable: null,
  _rowTimestamp: null,
  requiredBranchApprovalCount: null,
  isApprovedByConsensus: null,
  isSingleDeclineConsensusInvoked: null,
  isRejectOnUnderApprovalCount: null,
  isUsedForAdditionalDepartments: null,
  approvalBranches: [{ ...APPROVAL_BRANCH_INITIAL_VALUES }],
};
export const APPROVAL_SETUP_INITIAL_VALUES: ApprovalValues = {
  approvalTypeId: null,
  priorityNumber: null,
  name: null,
  description: null,
  approvalType: null,
  isAddApproversEligible: true,
  isPrimary: false,
  isNewApprovalSelectable: true,
  isDelayedApproverAllowed: false,
  notesByEntityId: null,
  entityDocumentsByEntityId: null,
  approvalSetupHistoriesByEntityId: null,
  approvalPhaseTypeId: null,
  approvalPhaseType: null,
  badgeColor: null,
  approvalTrees: [{ ...APPROVAL_LEVELS_INITIAL_VALUES }],
  approvalSelectionConditions: [{ ...REQUESTOR_INITIAL_VALUES }],
};

// {
//   "approval": {
//       "approvalTypeId": 71,
//       "name": "John Doe",
//       "priorityNumber": 3434,
//       "description": null,
//       "approvalPhaseTypeId": null,
//       "isAddApproversEligible": false,
//       "isPrimary": false,
//       "isNewApprovalSelectable": false,
//       "isDelayedApproverAllowed": false
//   },
//   "approvalConditions": [],
//   "approvalTreeBranches": [
//       {
//           "approvalTree": {
//               "approvalLevel": 1,
//               "name": "23jbk",
//               "description": "1",
//               "requiredBranchApprovalCount": 2,
//               "isApprovedByConsensus": null,
//               "isSingleDeclineConsensusInvoked": null,
//               "isRejectOnUnderApprovalCount": null,
//               "isUsedForAdditionalDepartments": null
//           },
//           "approvalBranches": [
//               {
//                   "description": "3123123",
//                   "branchOrder": 1,
//                   "budgetLimitAmount": null,
//                   "budgetLimitPercent": null,
//                   "isOverBudgetSelector": null,
//                   "isBusinessUnitSelector": null,
//                   "isDepartmentSelector": null,
//                   "isProjectSelector": null,
//                   "isUserGroupSelector": null,
//                   "isWorkgroupSelector": null,
//                   "transactionStartAmountTotal": null,
//                   "transactionEndAmountTotal": null,
//                   "transactionAmountConversionTypeId": null,
//                   "approverTransactionTypeId": null,
//                   "transactionBusinessUnitId": null,
//                   "transactionDepartmentId": null,
//                   "transactionDepartmentGroupId": null,
//                   "requesterUserId": null,
//                   "isTransactionNotCondition": null,
//                   "approverDelayDays": 0,
//                   "approverDelayHours": 0,
//                   "approverDelayStatusTypeId": null
//               }
//           ]
//       }
//   ]
// }
